<template>
  <div class="gift-management">
    <el-card class="page-container">
      <h1 class="title-biaoti">礼物管理</h1>
      
      <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
        <el-tab-pane label="礼物配置" name="giftConfig">
          <gift-config ref="giftConfig" />
        </el-tab-pane>
        <el-tab-pane label="定制礼物审核" name="customizedReview">
          <customized-gift-review ref="customizedReview" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import GiftConfig from './GiftConfig.vue'
import CustomizedGiftReview from './CustomizedGiftReview.vue'

export default {
  name: 'GiftManagement',
  components: {
    GiftConfig,
    CustomizedGiftReview
  },
  data() {
    return {
      activeTab: 'giftConfig'
    }
  },
  methods: {
    handleTabClick(tab) {
      // 可以在这里处理tab切换的逻辑
      console.log('切换到tab:', tab.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.gift-management {
  .page-container {
    margin: 20px;
    
    h1 {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
  
  :deep(.el-tabs__content) {
    padding: 0;
  }
  
  :deep(.el-tab-pane) {
    padding: 0;
  }
}
</style>
